export const inputWeekToApiWeek = (inputWeek) => {
    if (!inputWeek) return '';
    return inputWeek.replace('-W', '_');
};

export const apiWeekToInputWeek = (apiWeek) => {
    if (!apiWeek) return '';
    return apiWeek.replace('_', '-W');
};

export const dateToApiWeek = (dateValue) => {
    if (!dateValue) return '';

    const [year, month, day] = dateValue.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yearStart = new Date(year, 0, 1);
    const timezoneOffset = (yearStart.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000;
    const daysSinceYearStart = (date - yearStart + timezoneOffset) / (1000 * 60 * 60 * 24);
    const weekNumber = Math.floor(daysSinceYearStart / 7) + 1;

    return `${year}_${String(weekNumber).padStart(2, '0')}`;
};
